import React, { createContext, useContext, useEffect, useState } from "react";
import { adminMe, getToken, setToken, clearToken } from "../lib/adminApi";

const AdminAuthContext = createContext(null);
export const useAdminAuth = () => useContext(AdminAuthContext);

export function AdminAuthProvider({ children }) {
  const [status, setStatus] = useState("checking"); // checking | in | out
  const [username, setUsername] = useState(null);

  useEffect(() => {
    if (!getToken()) {
      setStatus("out");
      return;
    }
    adminMe()
      .then((d) => {
        setUsername(d.username);
        setStatus("in");
      })
      .catch(() => {
        clearToken();
        setStatus("out");
      });
  }, []);

  const login = (token, name) => {
    setToken(token);
    setUsername(name);
    setStatus("in");
  };
  const logout = () => {
    clearToken();
    setUsername(null);
    setStatus("out");
  };

  return (
    <AdminAuthContext.Provider value={{ status, username, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
